module.exports = __webpack_public_path__ + "media/photography/galleryImage10New-97812326.jpg";